import localStorage from './local-storage';

const NAME = 'subscriptionStart';
//period in minutes
const PERIOD = 15;

export default {
  start: function() {
    if (!localStorage.getItem(NAME)) {
      localStorage.setItem(NAME, Date.now());
    }
  },
  isWithinPeriod: function() {
    if (!localStorage.getItem(NAME)) {
      return false;
    }
    return Number(localStorage.getItem(NAME)) + PERIOD * 60000 > Date.now()
      ? true
      : false;
  }
};
